'use strict';

export default {
    inventory: {
        defaultPerPage: 18,
    },
};
